import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/common/common.service';

@Component({
  selector: 'app-reporting-management',
  templateUrl: './reporting-management.component.html',
  styleUrls: ['./reporting-management.component.css']
})
export class ReportingManagementComponent implements OnInit {
  userData:any;
  constructor(private common:CommonService) { }

  ngOnInit() {
    this.userData = this.common.getUser();
  }

}
